import { Deserializable } from '../../deserializable';

export class OfferActivityDto implements Deserializable {
  public TypeCode: string;
  public ChannelCode: string;
  public StatusCode: string;
  public ChangedBy: string;
  public ErrorCode: string;
  public ChangedFor: string;
  public ChangeDate?: Date;
  public Version?: number;

  public deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
